export const dictionary: any = {
	keep_name: { FA: 'کیپ', EN: 'Keep' },
	hero_title: { FA: 'بانک، ولی دلاری', EN: 'Dollar Banking' },
	hero_description: {
		FA: 'پس‌انداز و سرمایه‌گذاری دلاری',
		EN: 'The neobank for Middle East',
	},

	'Download App': { FA: 'دانلود کیپ', EN: 'Download App' },
	'Watch Video': { FA: 'مشاهده ویدیو', EN: 'Watch Video' },
	'Learn More': { FA: 'بیشتر بدانید ', EN: 'Learn More' },

	'Send, Receive, Buy with Cards': { FA: 'دریافت، ارسال و خرید با کارت', EN: 'Send, Receive, Buy with Cards' },
	'Powered By Blockchains': { FA: 'نیرو گرفته از بلاکچین', EN: 'Powered by Blockchains' },
	'Digital goods & services': { FA: 'اشتراک استارلینک و خدمات دیجیتال', EN: 'Buy StarLink Subscription & More' },

	'Payment services': { FA: 'خدمات بانکی و پرداخت', EN: 'Banking and Payments' },
	payment_services_opt1: { FA: 'دریافت و انتقال دلار، منطبق با GENIUS Act', EN: 'Send & Receive Dollars, Genius Act Compliant' },
	payment_services_opt2: { FA: 'نمایندگی فروش Starlink', EN: 'Exclusive Reseller of Starlink Subscription' },
	payment_services_opt3: { FA: 'دریافت ویزا کارت و مسترکارت', EN: 'Get Visa and Mastercard' },
	payment_services_opt4: { FA: 'درگاه پرداخت و حسابداری برای کسب‌وکار شما', EN: 'Payment Gateway and Accounting for your Business' },

	'Use DeFi': { FA: 'خدمات مالی و سرمایه گذاری', EN: 'Financial and Investment Services' },
	use_deFi_opt1: { FA: 'سرمایه گذاری در اوراق خزانه و کسب سود دلاری', EN: 'Invest in US Treasuries and Earn Interest' },
	use_deFi_opt2: { FA: 'خرید و فروش ۲۴ ساعته طلا', EN: 'Buy and Sell Gold 24/7' },
	use_deFi_opt3: { FA: 'سرمایه گذاری در سهام شرکت‌های آمریکایی', EN: 'Invest in US Stocks' },

	installation1_title: { FA: 'پولت رو کیپ کن!', EN: 'Keep Calm and Keep Your Freedom!' },
	installation1_description: {
		EN: 'With Keep, only you have control over your account.',
		FA: 'با کیپ، تنها شما کنترل حساب خود را دارید.',
	},

	'DOWNLOAD APK': { FA: 'دانلود APK', EN: 'DOWNLOAD APK' },
	'GET IT ON': { FA: 'دریافت از', EN: 'GET IT ON' },

	'CARD NUMBER': { FA: '۶۹۴۲ ۸۸۹۶ ۰۸۹۸ ۱۴۰۴', EN: '6942 8896 0898 1404' },
	'CARD HOLDER': { FA: 'کاوه آهنگر', EN: 'Kaveh Aghangar' },
	'EXPIRY DATE': { FA: '۰۳/۲۷', EN: '03/27' },

	steps_title: { FA: 'در ۳ مرحله ساده شروع کنید!', EN: 'Get Started in 3 simple steps' },
	'Create an account': { FA: 'ساخت حساب کاربری', EN: 'Create an account' },
	'setup/import secret phrases': { FA: 'احراز هویت آنلاین و سریع', EN: 'Online and Fast Authentication' },
	'boom! send/receive/buy/swap your assets!': {
		FA: 'دسترسی به حساب دلاری و سرمایه گذاری',
		EN: 'Access to Dollar Banking and Investments',
	},
	Step: { FA: 'مرحله', EN: 'Step' },
	'01': { FA: '1', EN: '01' },
	'02': { FA: '2', EN: '02' },
	'03': { FA: '3', EN: '03' },

	blockchains_title: { FA: 'بلاک چین هایی که پشتیبانی میشود', EN: 'Supported Blockchain' },
	blockchains_description: {
		FA: 'توسط بلاک چین های پیشرفته و امن تامین می شود',
		EN: 'KEEP is powered by advanced and secure blockchains',
	},

	'More Coming': {
		FA: 'به زودی',
		EN: `More
		 Coming`,
	},
	Coming: {
		FA: 'به زودی',
		EN: 'Coming',
	},

	installation2_title: {
		FA: 'دوستانت رو هم دعوت کن!',
		EN: 'Invite your friends to join!',
	},
	installation2_description: {
		FA: 'همین الان کیپ رو نصب کن و دوستانت رو هم دعوت کن و جایزه بگیر!',
		EN: 'Install KEEP right now and invite your friends to win a prize!',
	},

	footer_1_title: {
		FA: 'Security',
		EN: 'Security',
	},
	footer_1_des: {
		FA: 'امنیت کیپ، با تکنولوژی‌های رمزنگاری و مکانیزم‌های اجماع تامین شده است.',
		EN: 'KEEP is secured by cryptographic algorithms and consensus mechanisms of blockchains.',
	},
	footer_2_title: {
		FA: 'متن باز OpenSource',
		EN: 'Open Source',
	},
	footer_2_des: {
		FA: 'با هدف ترویج فرهنگ متن‌باز، کیپ به صورت متن باز توسعه پیدا می‌کند.',
		EN: 'We believe in the open source software and as long as the security is not compromised, we plan to keep it open source',
	},
	footer_3_title: {
		FA: 'عدم تمرکز',
		EN: 'Decentralization',
	},
	footer_3_des: {
		FA: 'کیپ از حامیان فرهنگ عدم تمرکز است و با کیپ، کنترل کامل دارایی‌های شما در اختیار شماست. حتی تیم کیپ نیز کنترلی بر دارایی‌های شما ندارد.',
		EN: 'We believe in decentralization and self-custody. With Keep, you keep self-custody of your assets.',
	},
	Features: {
		FA: 'دسترسی سریع',
		EN: 'Features',
	},
	About: {
		FA: 'درباره ما',
		EN: 'About',
	},
	Download: {
		FA: 'دانلودها',
		EN: 'Download',
	},
	Documentation: {
		FA: 'داکیومنت ها',
		EN: 'Documentation',
	},
	Security: {
		FA: 'امنیت',
		EN: 'Security',
	},
	Legal: {
		FA: 'مجوزها',
		EN: 'Legal',
	},
	'Privacy Policy': {
		FA: 'Privacy Policy',
		EN: 'Privacy Policy',
	},
	'Terms of Use': {
		FA: 'Terms of Use',
		EN: 'Terms of Use',
	},
	'Download Links': {
		FA: 'لینک های دانلود',
		EN: 'Download Links',
	},
	'Under Construction': {
		FA: 'در حال احداث. کارگران مشغول کارند! :دی',
		EN: 'Under Construction. Caution: Men & Women at Work! :D',
	},
};
